/**
 * API Endpoints Configuration
 * Centralized endpoint definitions for all API calls
 */

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://craksha.habilelabs.io";

export const endpoints = {
  // Authentication endpoints
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    logout: `${API_BASE_URL}/auth/logout`,
    // register: `${API_BASE_URL}/auth/register`,
    changePassword: `${API_BASE_URL}/auth/change-password`,
    forgotPassword: `${API_BASE_URL}/auth/forgot-password`,
    resetPassword: `${API_BASE_URL}/auth/reset-password`,
    refreshToken: `${API_BASE_URL}/auth/refresh`,
    verifyEmail: `${API_BASE_URL}/auth/verify-email`,
  },

  // User endpoints
  users: {
    getAll: `${API_BASE_URL}/users`,
    getById: (id: string) => `${API_BASE_URL}/users/${id}`,
    create: `${API_BASE_URL}/users`,
    createManager: `${API_BASE_URL}/admin/managers/`,
    exportManagers: `${API_BASE_URL}/admin/managers/export`,
    getManagerIds: `${API_BASE_URL}/admin/managers/ids`,
    updateManager: (userId: string) =>
      `${API_BASE_URL}/admin/managers/${userId}`,
    updateManagerStatus: (userId: string) =>
      `${API_BASE_URL}/admin/managers/${userId}/status`,
    update: (id: string) => `${API_BASE_URL}/users/${id}`,
    delete: (id: string) => `${API_BASE_URL}/users/${id}`,
    profile: `${API_BASE_URL}/users/profile`,
    updateProfile: `${API_BASE_URL}/users/profile`,
  },

  // Dashboard endpoints
  dashboard: {
    activityLogs: `${API_BASE_URL}/admin/dashboard/activity-logs`,
    activityLogsExport: `${API_BASE_URL}/admin/dashboard/activity-logs/export`,
    scanActivity: `${API_BASE_URL}/admin/dashboard/scan-activity`,
    summary: `${API_BASE_URL}/admin/dashboard/summary`,
    vehicles: `${API_BASE_URL}/admin/dashboard/vehicles`,
    vehiclesExport: `${API_BASE_URL}/admin/dashboard/vehicles/export`,
    overview: `${API_BASE_URL}/dashboard/overview`,
    stats: `${API_BASE_URL}/dashboard/stats`,
    charts: `${API_BASE_URL}/dashboard/charts`,
  },

  vehicles: {
    details: `${API_BASE_URL}/vehicles/details`,
    hydroCertificates: `${API_BASE_URL}/vehicles/hydro-certificates`,
  },

  // Roles and Permissions endpoints
  roles: {
    getAll: `${API_BASE_URL}/roles`,
    getById: (id: string) => `${API_BASE_URL}/roles/${id}`,
    create: `${API_BASE_URL}/roles`,
    update: (id: string) => `${API_BASE_URL}/roles/${id}`,
    delete: (id: string) => `${API_BASE_URL}/roles/${id}`,
  },

  // Audit logs endpoints
  auditLogs: {
    getAll: `${API_BASE_URL}/audit-logs`,
    getById: (id: string) => `${API_BASE_URL}/audit-logs/${id}`,
  },

  // Stations/Onboarding endpoints
  stations: {
    getAll: `${API_BASE_URL}/stations`,
    export: `${API_BASE_URL}/stations/export`,
    getById: (id: string) => `${API_BASE_URL}/stations/${id}`,
    create: `${API_BASE_URL}/stations`,
    updateStatus: (id: string) => `${API_BASE_URL}/stations/${id}/status`,
    update: (id: string) => `${API_BASE_URL}/stations/${id}`,
    delete: (id: string) => `${API_BASE_URL}/stations/${id}`,
    onboard: `${API_BASE_URL}/stations/onboard`,
  },

  qrTemplates: {
    createBulkWithQr: `${API_BASE_URL}/admin/templates/with-qr/bulk`,
    getBulkWithQrByBatchId: (batchId: string) =>
      `${API_BASE_URL}/admin/templates/with-qr/bulk/${batchId}`,
    downloadBulkWithQrByBatchId: (batchId: string) =>
      `${API_BASE_URL}/admin/templates/with-qr/bulk/${batchId}/download`,
  },
};

export default endpoints;
